<template>
	<vxe-modal v-model="modalShow" width="600" show-footer>
		<template #title>
			<span style="color:red">批量重开</span>
		</template>
		<template #default>
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
			</el-checkbox>
			<div style="margin: 15px 0;"></div>
			<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
				<el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
			</el-checkbox-group>
		</template>
	</vxe-modal>
</template>
<style>

</style>

<script>
	const cityOptions = ['上海', '北京', '广州', '深圳'];
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modalShow:false,
				checkAll: false,
				checkedCities: ['上海', '北京'],
				cities: cityOptions,
				isIndeterminate: true
			}
		},
		watch: {

		},
		mounted() {
			this.init()
		},
		computed: {

		},

		methods: {
			init(){
				this.$api.invoicecustomerorder.gettotalerror().then((res)=>{
					console.log(res)
				})
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? cityOptions : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
			}
		},
		components: {

		}
	}
</script>
